import IntroForm from "./IntroForm";
import Nav from "./nav";

function IntroFormModal() {
  return (
    <>
      <Nav />
      <IntroForm submitForm={(form) => {}} />;
    </>
  );
}

export default IntroFormModal;
